var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4904_41272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66668 3.50008V3.03341C4.66668 2.00091 4.66668 1.16675 6.53334 1.16675H7.46668C9.33334 1.16675 9.33334 2.00091 9.33334 3.03341V3.50008M4.66668 12.8334H9.33334C11.6783 12.8334 12.0983 11.8942 12.2208 10.7509L12.6583 6.08425C12.8158 4.66092 12.4075 3.50008 9.91668 3.50008H4.08334C1.59251 3.50008 1.18418 4.66092 1.34168 6.08425L1.77918 10.7509C1.90168 11.8942 2.32168 12.8334 4.66668 12.8334Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16665 8.17842V7.58341C8.16665 7.00008 8.16665 7.00008 7.58332 7.00008H6.41665C5.83332 7.00008 5.83332 7.00008 5.83332 7.58341V8.18425M8.16665 8.17842C8.16665 8.81425 8.16082 9.33341 6.99999 9.33341C5.84499 9.33341 5.83332 8.82008 5.83332 8.18425M8.16665 8.17842C9.77911 7.97767 11.3144 7.37159 12.6292 6.41675M5.83332 8.18425C4.32249 8.01508 2.84082 7.47258 1.52832 6.57425",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4904_41272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.f60596638e5ec18549d2bc63c4d13b71.svg";
export { ForwardRef as ReactComponent };